export default "__VITE_ASSET__7582513f__"